var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5859 0.859375C20.7031 0.390625 20.5859 0 19.8828 0H17.5781C16.9922 0 16.7188 0.3125 16.5625 0.664062C16.5625 0.664062 15.3906 3.51562 13.75 5.39062C13.2031 5.89844 12.9688 6.09375 12.6562 6.09375C12.5391 6.09375 12.3047 5.89844 12.3047 5.42969V0.859375C12.3047 0.273438 12.1484 0 11.6406 0H8.04688C7.65625 0 7.46094 0.273438 7.46094 0.546875C7.46094 1.09375 8.28125 1.21094 8.35938 2.77344V6.17188C8.35938 6.91406 8.24219 7.07031 7.92969 7.07031C7.14844 7.07031 5.27344 4.17969 4.14062 0.898438C3.90625 0.273438 3.67188 0 3.08594 0H0.78125C0.15625 0 0 0.3125 0 0.664062C0 1.28906 0.78125 4.29688 3.63281 8.32031C5.54688 11.0547 8.24219 12.5 10.6641 12.5C12.1094 12.5 12.3047 12.1875 12.3047 11.6406C12.3047 9.02344 12.1875 8.75 12.8906 8.75C13.2422 8.75 13.8281 8.94531 15.1953 10.2734C16.7578 11.8359 17.0312 12.5 17.8906 12.5H20.1953C20.8594 12.5 21.1719 12.1875 20.9766 11.5234C20.5469 10.1953 17.6172 7.38281 17.4609 7.1875C17.1094 6.75781 17.2266 6.5625 17.4609 6.17188C17.4609 6.17188 20.2734 2.1875 20.5859 0.859375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.4658aaddf44b1d705bc7fc586abb3c52.svg";
export { ForwardRef as ReactComponent };